// Class strings for surfaces that several primitives draw identically.

/** The raised, field-height surface behind inputs, selects and value fields. */
export const fieldSurface = "h-10 rounded-lg bg-surface shadow-raised";

/** A floating panel: popovers, menus and select lists. */
export const popupSurface =
  "z-(--z-overlay) origin-(--transform-origin) border border-gray-400 bg-surface text-fg shadow-xs transition-[scale,opacity] duration-150 data-ending-style:scale-95 data-starting-style:scale-95 data-ending-style:opacity-0 data-starting-style:opacity-0";

/** The scrolling list inside a menu or select popup. */
export const menuPopup =
  "max-h-(--available-height) overflow-y-auto overflow-x-hidden rounded-xl p-1";

/** A row in a menu or select list. */
export const menuItem =
  "relative flex h-9 cursor-pointer items-center gap-1.5 rounded-lg px-2 py-1.5 font-[450] text-sm outline-hidden hover:bg-gray-300 data-highlighted:bg-gray-300 data-highlighted:text-fg data-disabled:pointer-events-none data-disabled:opacity-50";
